'use strict';

var curry2 = require('../_internal/_curry2');

module.exports = curry2(function pickBy(cb, obj) {
  return Object.keys(obj).reduce(function (acc, key) {
    if (cb(obj[key], key)) acc[key] = obj[key];
    return acc;
  }, {});
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/nanoutils/cjs/pickBy/index.js
// module id = 430
// module chunks = 0